<template>
	<div class="landing-progress-loader" :class="`landing-progress-loader_theme_${theme}`">
		<h3 class="landing-progress-loader__label">{{ label ?? $t('landing_male.loader.label') }}</h3>

		<div class="landing-progress-loader__bar">
			<div class="landing-progress-loader__bar-inner" :style="{ width: value.progress + '%' }" />
		</div>

		<p class="landing-progress-loader__note">{{ note ?? $t('landing_male.loader.note') }}</p>
	</div>
</template>

<script>
import anime from 'animejs'

const createSteps = () => {
	let array = []
	array.push(anime.random(10, 30))
	array.push(anime.random(array[0], 50))
	array.push(anime.random(array[1], 60))
	array.push(anime.random(array[2], 70))
	array.push(anime.random(array[3], 80))
	array.push(anime.random(array[4], 90))
	array.push(100)
	return array
}

export default {
	name: 'LandingProgressLoader',

	props: {
		duration: {
			type: Number,
			required: true,
		},

		label: {
			type: String,
			default: null,
		},

		note: {
			type: String,
			default: null,
		},

		theme: {
			type: String,
			default: 'default',
			validator: (value) => ['default', 'transparent', 'white'].includes(value),
		},
	},

	emits: ['progressLoaderStarted', 'progressLoaderCompleted'],

	data() {
		return {
			value: {
				progress: 0,
			},
		}
	},

	created() {
		const easing = `cubicBezier(${['.37,.84,.59,.09', '.4,.75,.62,.21', '.44,.66,.66,.38'][anime.random(0, 2)]})`
		const animeTarget = { progress: 0 }

		anime({
			progress: createSteps(),
			duration: this.duration,
			targets: animeTarget,
			easing: easing,
			begin: (e) => {
				this.$emit('progressLoaderStarted', e)
			},
			update: () => {
				this.value.progress = animeTarget.progress
			},
			complete: () => {
				this.value.progress = animeTarget.progress
				this.$emit('progressLoaderCompleted')
			},
		})
	},
}
</script>

<style lang="scss" scoped>
.landing-progress-loader {
	margin: 0 0 var(--size-24);

	text-align: center;

	color: var(--Text-Primary-100);

	&__label {
		margin: 0 0 var(--size-12) 0;

		font-size: var(--size-16);
		line-height: var(--size-22);
		font-weight: 600;
	}

	&__bar {
		height: var(--size-10);
		margin: 0 var(--size-20);
		overflow: hidden;

		border-radius: var(--size-8);

		background-color: var(--Fill-Tertiary);

		&-inner {
			width: 0;
			height: 100%;

			background-color: var(--Fill-Accent-100);
		}
	}

	&__note {
		margin: var(--size-12) 0 0 0;

		font-size: var(--size-16);
		line-height: var(--size-20);
		font-weight: 500;
	}
}

.landing-progress-loader_theme_transparent {
	color: var(--Text-White-100);

	.landing-progress-loader__label {
		color: var(--Text-White-100);
	}

	.landing-progress-loader__bar {
		background-color: #ffffff4d;
	}

	.landing-progress-loader__bar-inner {
		background-color: var(--Fill-Accent-100);
	}

	.landing-progress-loader__note {
		color: var(--Text-White-100);
	}
}

.landing-progress-loader_theme_white {
	color: var(--Text-White-100);

	.landing-progress-loader__label,
	.landing-progress-loader__note {
		color: var(--Text-White-100);
	}

	.landing-progress-loader__bar {
		background-color: #ffffff40;
	}

	.landing-progress-loader__bar-inner {
		background-color: var(--Fill-White);
	}
}
</style>
